import { GridColumnType } from "../../../../data/gridColumnType";

export const PricingTableConfig= {
    columns: [
      {
        name: "Item Description",
        fieldName: "itemDescription",
        allowShort: false,
        colType: GridColumnType.Text,
        
      },
      {
        name: "Cost",
        fieldName: "cost",
        allowShort: false,
        colType: GridColumnType.Text,
      },
    ],
  };
  